<template>
  <div class="personalBox" v-loading="loading">
    <div class="personalMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/users/home' }"
            >个人中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>个人认证</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="hintBox ft12">提示：请准备好相关材料后，开启实名认证！</div>
      <div class="personalCon" v-show="error">
        <div class="flowChart">
          <ul class="ft14">
            <li>
              <span class="personStep"></span>
            </li>
            <li>
              <div class="circle personStep">
                <span></span>
              </div>
              <p class="personText">选择认证类型</p>
            </li>
            <li>
              <span></span>
            </li>
            <li>
              <div class="circle">
                <span></span>
              </div>
              <p>提交认证资料</p>
            </li>
            <li>
              <span></span>
            </li>
            <li>
              <div class="circle">
                <span></span>
              </div>
              <p>人脸识别认证</p>
            </li>
            <li>
              <span></span>
            </li>
            <li>
              <div class="circle">
                <span></span>
              </div>
              <p>提交完成</p>
            </li>
            <li>
              <span></span>
            </li>
          </ul>
        </div>
        <div class="personalChoose textAlign" v-show="personalTabOne">
          <div class="personalStep">
            <ul>
              <li>
                <img
                  src="../../../assets/images/PersonalCertificate/Bank card_icon_nor.png"
                  alt
                />
                <p>银行卡四要素认证</p>
                <b>此功能即将开通</b>
              </li>
              <li>
                <img
                  src="../../../assets/images/PersonalCertificate/Id card_icon_hov_pre.png"
                  alt
                />
                <p>身份证认证</p>
              </li>
              <li>
                <img
                  src="../../../assets/images/PersonalCertificate/face_icon_nor.png"
                  alt
                />
                <p>公安部人脸识别</p>
                <b>此功能即将开通</b>
              </li>
            </ul>
          </div>
          <span class="nextFn ft12" @click="nextFn">下一步</span>
        </div>
        <div class="personalChoose textAlign" v-show="personalTabTwo">
          <p class="face-title">
            <img
              src="../../../assets/images/personalSign/errorface.png"
            />选择您的证件类型，并正确填写身份认证信息，以便快速通过认证。
          </p>
          <div class="cardMain ft14">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <!-- <el-form-item label="认证类型：" prop="types"> <el-input
                  type="text"
                  v-model="ruleForm.types"
                  autocomplete="off"
                  @blur="changesName"
                  disabled
                  placeholder="认证类型"
              ></el-input></el-form-item>-->
              <el-form-item label="证件类型：" prop="regionType">
                <el-select
                  v-model="ruleForm.regionType"
                  placeholder="请选择证件类型"
                  @change="wacthRegionType"
                >
                  <el-option
                    v-for="item in documentType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="国籍："
                prop="nationality"
                v-if="ruleForm.regionType != 1"
              >
                <el-select
                  v-model="ruleForm.nationality"
                  placeholder="请选择国籍"
                  :disabled="isNationAble"
                  class="search_nation_p"
                  @visible-change="wacthNationValue"
                >
                  <div class="search_nation_box">
                    <p class="search_nation">
                      <img
                        src="../../../assets/images/PersonalCertificate/searc_nation.png"
                      />
                      <input
                        placeholder="搜索国家/地区名称"
                        v-model="searchNationValue"
                        @input="searchNationality"
                      />
                    </p>
                  </div>
                  <div style="height: 40px"></div>
                  <el-option
                    v-for="item in nationalityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <!-- <el-select v-else v-model="ruleForm.nationality" placeholder="请选择国籍" :disabled="isNationAble"  class="search_nation_p">
                    <el-option
                      v-for="item in nationalityListnew"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>-->
              </el-form-item>
              <el-form-item label="姓名：" prop="name">
                <el-input
                  type="text"
                  v-model="ruleForm.name"
                  autocomplete="off"
                  @blur="changesName"
                  placeholder="请填写姓名"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="性别："
                prop="usersex"
                v-if="ruleForm.regionType != 1"
              >
                <el-select v-model="ruleForm.usersex" placeholder="请选择性别">
                  <el-option
                    v-for="item in sexArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <template v-if="ruleForm.regionType != 1">
                <el-form-item label="出生日期：" prop="birthDate">
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="ruleForm.birthDate"
                    placeholder="请选择您的出生日期"
                  ></el-date-picker>
                </el-form-item>
                <div style="display: flex">
                  <!-- <el-form-item label="证件有效期：" class="dataStartEnd"  prop="dataStart">
                 <el-date-picker
                     type="date"
                  value-format="yyyy-MM-dd"
                    v-model="ruleForm.dataStart"
                    placeholder="开始日期">
                  </el-date-picker>
                  </el-form-item>-->
                  <el-form-item prop="dataEnd" label="证件有效期：">
                    <el-date-picker
                      type="date"
                      value-format="yyyy-MM-dd"
                      v-model="ruleForm.dataEnd"
                      placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                </div>
                <el-form-item label="证件号码：" prop="cardID">
                  <el-input
                    type="text"
                    v-model="ruleForm.cardID"
                    autocomplete="off"
                    @blur="changescardID"
                    placeholder="输入证件号码"
                  ></el-input>
                </el-form-item>
              </template>

              <el-form-item
                label="身份证号码："
                prop="card"
                v-if="ruleForm.regionType == 1"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.card"
                  autocomplete="off"
                  @blur="changesCode"
                  placeholder="输入身份证号码"
                ></el-input>
              </el-form-item>
              <el-form-item class="ft12 tiJiao">
                <!-- <el-button @click="lastStepFn">上一步</el-button> -->
                <el-button @click="resetForm('ruleForm')" style="display: none"
                  >重置</el-button
                >
                <el-button type="primary" @click="tiJiaoFn('ruleForm')"
                  >提交</el-button
                >
                <!-- <button type="primary" class="no-button-click" v-else disabled >提交</button> -->
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="personalChoose textAlign" v-show="personalTabThree">
          <!-- <div class="authenticationCard authenticationCardp ft14">
            <el-form :model="ruleFormP" :rules="rulesp" ref="ruleFormP" class="demo-ruleForm">
              <el-form-item label="手机号：" prop="photo" v-if="!type">
                <el-input type="text" v-model="ruleFormP.photo" placeholder="请输入您的手机号"></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="photo" v-if="type">
                <el-input
                  type="text"
                  v-model="ruleFormP.photo"
                  placeholder="请输入您的手机号"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
              <el-form-item label="短信验证码：" prop="code" class="codeBox">
                <el-input type="text" v-model="ruleFormP.code" placeholder="请输入验证码" class="fl"></el-input>
                <span v-show="sendAuthCode" class="code" @click="getCode">获取验证码</span>
                <span v-show="!sendAuthCode" class="code" style="color:#E88078">{{auth_time}}秒后重新获取</span>
              </el-form-item>
              <el-form-item class="ft12 tiJiao">
                <el-button @click="lastThreeFn">上一步</el-button>
                <el-button type="primary" @click="subCard('ruleFormP')">提交</el-button>
              </el-form-item>
            </el-form>
          </div>-->

          <!-- 人脸识别 -->
          <div class="facerecognition">
            <p class="face-title" v-show="!isStatusError">
              <img
                src="../../../assets/images/personalSign/errorface.png"
              />请使用微信或者其他软件扫描二维码，并依照提示完成人脸识别认证
            </p>
            <div class="rlsb">
              <p class="rlsb_title" v-show="!isStatusError">
                <span></span>&nbsp;二维码5分钟内有效&nbsp;<span></span>
              </p>
              <div
                class="erweima"
                v-show="
                  codeStatus != 0 &&
                  codeStatus != 1 &&
                  !error_num &&
                  !isStatusError
                "
              >
                <vue-qr
                  colorDark="#000"
                  :text="erweimaUrl"
                  :size="200"
                ></vue-qr>
              </div>
              <div
                class="erweima_errro"
                v-show="
                  error_erweima &&
                  codeStatus != 0 &&
                  codeStatus != 1 &&
                  !isStatusError
                "
              >
                <p class="error_title">二维码失效</p>
                <span class="update_erweima" @click="updateEr">点击刷新</span>
              </div>
              <div
                class="erweima_errro"
                style="width: 270px; margin-left: -135px"
                v-show="error_num"
              >
                <p class="error_title">{{ text }}</p>
              </div>
              <div
                class="erweima_success"
                v-show="
                  (status == 1 || status == 2) &&
                  codeStatus != 0 &&
                  codeStatus != 1 &&
                  !isStatusError
                "
              >
                <img
                  style="width: 30px"
                  src="../../../assets/images/PersonalCertificate/face_success_i.png"
                />
                <p class="success_title">扫描成功</p>
                <p class="success_desc">请在手机端刷脸认证</p>
                <span class="success_update_erweima" @click="updateEr"
                  >点击刷新</span
                >
              </div>
              <div
                class="erweima_success"
                v-show="codeStatus == 0 || codeStatus == 1"
              >
                <img
                  style="width: 30px"
                  src="../../../assets/images/PersonalCertificate/face_success_i.png"
                />
                <p class="success_title">人脸识别认证成功</p>
                <!-- <p class ="success_desc">请点击已完成人脸验证</p> -->
              </div>
              <div class="erweima_success" v-show="isStatusError">
                <img
                  src="../../../assets/images/PersonalCertificate/error_icon.png"
                  style="width: 50px"
                />
                <p class="success_title">人脸识别认证失败</p>
                <p class="success_desc">请正确核对您的信息</p>
                <span class="success_update_erweima" @click="resetReaml"
                  >重新认证</span
                >
              </div>
              <!-- <span class="submit_rlsb"  v-if="status==2" :style="{'margin-top':codeStatus==0 || codeStatus==1?'200px':'20px'}" @click="getFaceResult">已完成人脸验证</span>
                <span class="submit_rlsb"  v-else :style="{'margin-top':codeStatus==0 || codeStatus==1?'200px':'20px','background':'rgb(228, 226, 226)','color':'#fff'}">已完成人脸验证</span> -->
            </div>
          </div>
        </div>
        <div class="personalChoose textAlign" v-show="personalTabFour">
          <div class="subSucceed">
            <p class="ft24">
              <img
                src="../../../assets/images/PersonalCertificate/succeed_icon.png"
              />提交完成
            </p>
            <p class="ft16">您的信息正在审核中，请耐心等待</p>
            <span style="font-size: 12px; color: #e98880"
              >如果需要修改信息，请联系客服010-86208512</span
            >
          </div>
        </div>
      </div>
      <div class="errorBox" v-show="!error">
        <img src="../../../assets/images/enterprise/notpass_icon.png" />
        <h3>认证失败</h3>
        <p>身份信息不符，请重新发起认证！</p>
        <p>
          <span>请重新认证</span>
        </p>
      </div>
    </div>
    <div class="exampleBox" v-show="exampleBox">
      <div class="conentExamp selctedEampleBox">
        <img
          class="exampImg"
          src="../../../assets/images/PersonalCertificate/errormessage_img.png"
          alt
        />
        <img
          class="exampImg"
          src="../../../assets/images/PersonalCertificate/right_img.png"
          alt
        />
        <p class="ft14">
          <img
            src="../../../assets/images/PersonalCertificate/warn_icon.png"
          />提示：拍照时将相机（或手机）对焦在证件上（在手机屏幕上对着画面中的身份证按一下）使证件文字清晰，也必将使您的认证比别人更早通过哦！！
        </p>
        <b @click="closeExampleFn">
          <img
            src="../../../assets/images/PersonalCertificate/delete_icon.png"
          />
        </b>
      </div>
    </div>
    <Dialog
      :visible="CheckingInformation"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
    >
      <div slot="dialog">
        <div class="errorBox textAlign ft14">
          身份信息验证失败，请点击关闭重新进行认证！
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="hintBoxCon"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
    >
      <div slot="dialog">
        <div class="errorBox textAlign ft14">用户实名审核中，请耐心等待！</div>
      </div>
    </Dialog>
    <!-- 人脸识别失败 -->
    <face-error v-if="codeStatus == -1 && openTest" :text="text"></face-error>
  </div>
</template>
<script>
import Dialog from "../../common/Dialog.vue";
import $ from "jquery";
import BaseApi from "@lib/baseApi.js";
import country from "@lib/nationality.js";
import breadcrumb from "@common/Breadcrumb.vue";
import Util from "@lib/util.js";
import vueQr from "vue-qr"; //生成二维码插件
import faceError from "@common/faceError.vue";
import { mapMutations } from "vuex";
import cryptoJs from "@lib/secret.js";
export default {
  data() {
    var validateCard = (rule, value, callback) => {
      var common = /^[a-z|A-Z|0-9]{4,20}$/;
      if (!common.test(value)) {
        callback(new Error("您输入的格式不对"));
      }
      callback();
    };
    var validateCards = (rule, value, callback) => {
      var isIDCard =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!isIDCard.test(value)) {
        callback(new Error("您输入的格式不对"));
      }
      callback();
    };
    var validateName = (rule, value, callback) => {
      var isName = /^[a-zA-Z\s*]{2,20}$/, //英文名
        rareWords =
          /^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/; //普通汉字、生僻字
      if (!isName.test(value) && !rareWords.test(value)) {
        callback(new Error("您输入的格式不对"));
      }
      callback();
    };
    var valbirthDate = (rule, value, callback) => {
      let currentTime = new Date();
      let newDate = new Date(
        currentTime.getFullYear() + "",
        currentTime.getMonth() + 1 + "",
        currentTime.getDate() + ""
      ).getTime();
      let startTime = new Date(
        this.ruleForm.birthDate.slice(0, 4),
        this.ruleForm.birthDate.slice(5, 7),
        this.ruleForm.birthDate.slice(8, 10)
      ).getTime();
      if (startTime > newDate) {
        callback(new Error("选择的日期有误"));
      }
      callback();
    };
    var valdataEnd = (rule, value, callback) => {
      let currentTime = new Date();
      let newDate = new Date(
        currentTime.getFullYear() + "",
        currentTime.getMonth() + 1 + "",
        currentTime.getDate() + ""
      ).getTime();
      let startTime = new Date(
        this.ruleForm.dataEnd.slice(0, 4),
        this.ruleForm.dataEnd.slice(5, 7),
        this.ruleForm.dataEnd.slice(8, 10)
      ).getTime();
      if (startTime < newDate) {
        callback(new Error("选择的日期有误"));
      }
      callback();
    };
    return {
      erweimaUrl: "", //二维码信息
      sureClick: false,
      success_erweima: false, //二维码扫描成功
      error_erweima: false, //二维码失效
      signing: false, //二维码弹框
      orderNo: "", //订单号
      status: 0, //二维码状态
      codeStatus: null, //认证状态
      CheckingInformation: false,
      hintBoxCon: false,
      alltrue: false,
      errorMessage: "",
      error: true,
      sendAuthCode: true,
      auth_time: 0,
      loading: false,
      loadings: false,
      loadingss: false,
      loadingsss: false,
      exampleBox: false,
      personalTabOne: true,
      personalTabTwo: false,
      personalTabThree: false,
      personalTabFour: false,
      type: false,
      // imageUrl: "",
      // imageUrlc: "",
      // imageUrlz: "",
      datas: "/common/upload",
      arropen: [],
      idcardFrontWatermakedPath: "",
      idcardReverseWatermakedPath: "",
      handCardWatermakedPath: "",
      ruleForm: {
        name: "",
        card: "",
        regionType: "1", //证件类型
        types: "身份证",
        usersex: "",
        birthDate: "",
        // dataStart:"",
        dataEnd: "",
        nationality: "", //国籍
        cardID: "", //证件号
      },
      rules: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" },
          { validator: validateName, trigger: "blur" },
        ],
        card: [
          { required: true, message: "请输入18位身份证", trigger: "blur" },
          { validator: validateCards, trigger: "blur" },
        ],
        cardID: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { validator: validateCard, trigger: "blur" },
        ],
        regionType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        usersex: [{ required: true, message: "请选择性别", trigger: "change" }],
        birthDate: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
          { validator: valbirthDate, trigger: "blur" },
        ],
        //  dataStart: [
        //   { required: true, message: "请选择证件开始日期", trigger: "blur" },
        // ],
        dataEnd: [
          { required: true, message: "请选择证件失效日期", trigger: "blur" },
          { validator: valdataEnd, trigger: "blur" },
        ],
        nationality: [
          { required: true, message: "请选择国籍", trigger: "change" },
        ],
      },
      ruleFormP: {
        photo: "",
        code: "",
      },
      rulesp: {
        photo: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "您输入的不是手机号",
            trigger: "blur",
          },
        ],
        code: [{}],
      },
      //监听输入信息
      rulename: false,
      rulecode: false,
      userID: "",
      text: "",
      error_num: false,
      openTest: false,
      documentType: [
        {
          value: "1",
          label: "中国大陆二代身份证",
        },
        {
          value: "2",
          label: "定居国外的中国公民护照",
        },
        {
          value: "3",
          label: "港澳居民来往内地通行证",
        },
        {
          value: "4",
          label: "台湾居民来往大陆通行证",
        },
        {
          value: "5",
          label: "中华人民共和国外国人永久居留证",
        },
      ],
      sexArr: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      nationalityList: [],
      nationalityListnew: [],
      isNationAble: false,
      searchNationValue: "",
      isStatusError: false,
    };
  },
  methods: {
    ...mapMutations(["setCurrentInfo", "setUserInfo"]),
    //获取userId
    getuserId() {
      BaseApi.createRpcToken("/user/v2/getUserInfo", "GET")
        .then(
          (data) => {
            if (data.code == 200) {
              console.log("data", data);
              sessionStorage.setItem("userInfo", JSON.stringify(data.datas));
              localStorage.setItem("curID", data.datas.currentUserId);
              
              this.userInfoP = data.datas;
              this.userID = data.datas.person.userId;
              if (data.datas.enterpriseList.length) {
                this.detaiCurItem = data.datas.enterpriseList[0];
              }

              this.setUserInfo(data.datas);

              if (data.datas.person.authenticationStatus == 2) {
                this.$router.replace("/personal/users/home");
                setTimeout(() => {
                  location.reload();
                }, 500);
              }

              let userArr = data.datas.person;
              // let curInfo=userArr.filter(item=>item.userId==data.datas.currentUserId)
              if (data.datas.person.authenticationStatus == 1) {
                this.userStatus();
              }
              this.setCurrentInfo(userArr);
              // this.getFaceAuthOrderNo();
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //实名状态
    userStatus() {
      $(".flowChart li").eq(2).find("span").addClass("personStep");
      $(".flowChart li").eq(4).find("span").addClass("personStep");
      // $(".circle")
      //   .eq(1)
      //   .addClass("personStep");
      // $(".circle")
      //   .eq(2)
      //   .addClass("personStep");
      // $(".flowChart li")
      //   .eq(6)
      //   .find("span")
      //   .addClass("personStep");
      // $(".flowChart li")
      //   .eq(8)
      //   .find("span")
      //   .addClass("personStep");
      // $(".circle")
      //   .eq(3)
      //   .addClass("personStep");
      this.personalTabOne = false;
      this.personalTabTwo = true;
      this.personalTabThree = false;
      this.personalTabFour = false;
    },
    searchNationality() {
      if (this.searchNationValue == "") {
        this.nationalityList = country.country.filter(
          (item) => item.label != "中国"
        );
      } else {
        let newList = country.country.filter(
          (item) =>
            item.label.indexOf(this.searchNationValue) != -1 &&
            item.label != "中国"
        );
        if (newList.length) {
          this.nationalityList = newList;
        } else {
          this.nationalityList = country.country.filter(
            (item) => item.label != "中国"
          );
        }
      }
    },
    wacthRegionType(flag) {
      this.nationalityList = country.country;
      //  regionType=this.ruleForm.regionType
      if (this.ruleForm.regionType == 2) {
        this.ruleForm.nationality = "CHN";
        this.isNationAble = true;
      } else if (this.ruleForm.regionType == 4) {
        this.ruleForm.nationality = "CHN";
        this.isNationAble = true;
      } else if (this.ruleForm.regionType == 3) {
        this.ruleForm.nationality = "CHN";
        this.isNationAble = true;
      } else {
        this.isNationAble = false;
        if (!flag) {
          this.ruleForm.nationality = "";
        }
        this.nationalityList = country.country.filter(
          (item) => item.label != "中国"
        );
      }
      this.$refs.ruleForm.clearValidate();
    },
    wacthNationValue(data) {
      if (!data) {
        //false是弹框隐藏
        this.searchNationValue = "";
        this.nationalityList = country.country.filter(
          (item) => item.label != "中国"
        );
      }
    },
    //监听姓名输入信息
    changesName(e) {
      var isName = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
      if (!isName.test(e.target.value)) {
        this.rulename = false;
      } else {
        this.rulename = true;
      }
    },
    //监听身份证输入信息
    changesCode(e) {
      var isIDCard =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!isIDCard.test(e.target.value)) {
        this.rulecode = false;
      } else {
        this.rulecode = true;
      }
      this.ruleForm.card = this.ruleForm.card.toLocaleUpperCase();
    },
    getPresonInfo(flag) {
      let eId = "";
      let params = {
        type: 1,
        enterpriseId: "",
      };
      if (this.detaiCurItem) {
        if (
          this.detaiCurItem.authenticationStatus == 2 ||
          this.detaiCurItem.authenticationStatus == 1
        ) {
          params.enterpriseId = this.detaiCurItem.id;
          params.type = 2;
        } else {
          params.type = 1;
        }
      }

      BaseApi.createRpcToken("/user/v2/getUserAuthInfo", params)
        .then(
          (data) => {
            let detail = data.datas;
            this.detailAuth = data.datas;
            // this.userID=data.datas?data.datas.userId:"";
            if (data.datas) {
              this.userID = data.datas.userId;
            }
            if (detail) {
              if (flag) {
              } else {
                this.ruleForm.name = detail.realName;
                this.ruleForm.card = detail.idcardNumber;
                this.ruleForm.regionType =
                  detail.idType && detail.idType != "undefined"
                    ? detail.idType + ""
                    : "1"; //证件类型
                this.ruleForm.types = "身份证";
                if (detail.idType != 1) {
                  this.ruleForm.usersex = detail.sex ? detail.sex + "" : "1";
                  this.ruleForm.birthDate = detail.birthDate;
                  // this.ruleForm.dataStart=detail.expiryDate.join(',')[0];
                  this.ruleForm.dataEnd = detail.expiryDate
                    ? detail.expiryDate.split(" ")[0]
                    : "";
                  this.ruleForm.nationality = detail.nation; //国籍
                  this.ruleForm.cardID = detail.idcardNumber; //证件号
                }
                if (detail.checkStatus == 3 || detail.checkStatus == 1) {
                  $(".flowChart li").eq(2).find("span").addClass("personStep");
                  $(".circle").eq(1).addClass("personStep");
                  this.personalTabOne = false;
                  this.personalTabTwo = true;
                  this.personalTabThree = false;
                } else if (detail.checkStatus == 2) {
                  $(".flowChart li").eq(2).find("span").addClass("personStep");
                  $(".flowChart li").eq(3).find("span").addClass("personStep");
                  $(".flowChart li").eq(4).find("span").addClass("personStep");
                  $(".flowChart li").eq(6).find("span").addClass("personStep");
                  $(".flowChart li").eq(8).find("span").addClass("personStep");
                  $(".circle").eq(4).addClass("personStep");
                  $(".circle").eq(3).addClass("personStep");
                  $(".circle").eq(1).addClass("personStep");
                  $(".circle").eq(2).addClass("personStep");
                  this.personalTabOne = false;
                  this.personalTabTwo = false;
                  this.personalTabThree = false;
                  this.personalTabFour = true;
                }
                if (detail.nation) {
                  this.wacthRegionType(true);
                } else {
                  this.wacthRegionType();
                }
              }
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    nextFn() {
      $(".flowChart li").eq(2).find("span").addClass("personStep");
      $(".circle").eq(1).addClass("personStep");
      if (this.userInfoP.person.authenticationStatus == 5) {
        // $(".flowChart li")
        //   .eq(4)
        //   .find("span")
        //   .addClass("personStep");
        // $(".circle")
        //   .eq(2)
        //   .addClass("personStep");
        this.personalTabOne = false;
        this.personalTabTwo = true;
        this.personalTabThree = false;
        this.getPresonInfo();
      } else {
        this.getPresonInfo();
        this.personalTabOne = false;
        this.personalTabTwo = true;
      }
    },
    uploadHeader() {
      return {
        token: localStorage.token || "mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq",
        "X-CSRF-Token": sessionStorage.token,
        "request-id": Util.getUID(),
      };
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    lastStepFn() {
      // this.resetForm("ruleForm");
      $(".hintBox").css("display", "block");
      $(".flowChart li").eq(2).find("span").removeClass("personStep");
      $(".circle").eq(1).removeClass("personStep");
      this.personalTabOne = true;
      this.personalTabTwo = false;
    },
    tiJiaoFn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (
          //   this.idcardFrontWatermakedPath != "" &&
          //   this.idcardReverseWatermakedPath != ""
          //   //  &&
          //   // this.handCardWatermakedPath != ""
          // ) {
          // var queryStr = {
          //   realName: this.ruleForm.name,
          //   idcardNumber: this.ruleForm.card
          //   // idcardFrontWatermakedPath: this.idcardFrontWatermakedPath,
          //   // idcardReverseWatermakedPath: this.idcardReverseWatermakedPath,
          //   // handCardWatermakedPath: this.handCardWatermakedPath
          // };
          // BaseApi.createRpcToken(
          //   "/user/v2/personAuthentication",
          //   queryStr,
          //   "post"
          // )
          //   .then(
          //     data => {
          //       if (data.datas.code == 5001 || data.datas.code == 3023) {
          //         this.CheckingInformation = true;
          //         sessionStorage.setItem("personalTabThree", false);
          //       } else if (data.datas.code == 200) {
          $(".flowChart li").eq(4).find("span").addClass("personStep");
          $(".circle").eq(2).addClass("personStep");
          this.personalTabTwo = false;
          this.personalTabThree = true;
          sessionStorage.setItem("personalTabThree", true);
          // console.log("获取二维码")
          //获取二维码
          this.getFaceAuthOrderNo();
          //     } else if (data.datas.code == 3001) {
          //       this.hintBoxCon = true;
          //       sessionStorage.setItem("personalTabThree", false);
          //     }
          //   },
          //   data => {
          //     if (data.code == 107) {
          //       sessionStorage.setItem("personalTabThree", false);
          //       this.CheckingInformation = true;
          //     }
          //   }
          // )
          // .catch(function(e) {
          //   errorLog(e);
          // });
          // }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取实名人脸二维码
    async getFaceAuthOrderNo() {
      let userIDd = this.$route.query.userId
        ? this.$route.query.userId
        : this.userID;
      //第三步进行人脸识别验证
      let queryStrUrl = {
        liveType: 1,
        contractId: "",
        userId: userIDd,
      };
      var timer = null;
      // await this.getuserId();
      // await this.getPresonInfo(true);
      //获取二维码地址
      clearInterval(timer);
      BaseApi.createRpcToken("/user/getFaceAuthOrderNo", queryStrUrl, "GET")
        .then(
          (data) => {
            if (data.code == 200) {
              var endTime = new Date().getTime() + 5 * 60 * 1000;
              this.orderNo = data.datas.orderNo; //data.datas.url
              if (data.datas.orderNo != -1) {
                this.setTimerEr();
                let userIDd = localStorage.getItem("userId")
                    ? localStorage.getItem("userId")
                    : this.userID,
                  tokenId = localStorage.getItem("token"),
                  idNumbers =
                    this.ruleForm.regionType == 1
                      ? this.ruleForm.card.toLocaleUpperCase()
                      : this.ruleForm.cardID.toLocaleUpperCase(),
                  curTime = new Date().format("YYYY/MM/DD"); //加密格式：时间("YYYY/MM/DD")+内容${window.location.origin}  测试：https://gzfq_fq_test.ip360.org
                
                  this.erweimaUrl = `${
                  window.location.origin
                }/m/sign-perStartFace?orderNo=${
                  data.datas.orderNo
                }&idcardNumber=${cryptoJs.Encrypt(
                  curTime + idNumbers
                )}&typesP=1&realName=${cryptoJs.Encrypt(
                  curTime + this.ruleForm.name
                )}&idType=${this.ruleForm.regionType}&nation=${
                  this.ruleForm.nationality
                }&sex=${this.ruleForm.usersex}&birthDate=${
                  this.ruleForm.birthDate
                }&expiryDate=${this.ruleForm.dataEnd}&token=${tokenId}`;
                timer = setInterval(() => {
                  var start = new Date().getTime();
                  if (start > endTime) {
                    this.error_erweima = true;
                    this.status = 0;
                    clearInterval(timer);
                  } else {
                    if (this.status == 1 || this.status == 2) {
                      clearInterval(timer);
                      this.error_erweima = false;
                    } else {
                      this.error_erweima = false;
                    }
                  }
                }, 1000);
                if (this.status == 1 || this.status == 2) {
                  clearInterval(timer);
                  this.error_erweima = false;
                }
              } else {
                this.text = " 人脸识别服务异常，请联系管理员！";
                this.error_num = true;
                this.status = 0;
                this.error_erweima = false;
              }
            } else {
              // console.log('erweimadizhi error',data)
              this.error_erweima = true;
              this.status = 0;
            }
          },
          (data) => {
            if (data.code == 107) {
              this.error_erweima = true;
            }
          }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //实时获取二维码状态
    setTimerEr() {
      var timer = null;
      let orderNos = this.orderNo;
      var obj = { orderNo: orderNos };
      BaseApi.createRpcToken(
        "/user/getFaceAuthStatus",
        { orderNo: orderNos },
        "GET"
      )
        .then(
          (data) => {
            if (data.code == 200) {
              clearTimeout(timer);
              this.status = data.datas.status;
              this.codeStatus = data.datas.authStauts;
              let self = this;
              if (self && !self._isDestroyed) {
                //组件是否被销毁
                timer = setTimeout(() => {
                  this.setTimerEr();
                }, 1000);
              }
              if (obj.orderNo != this.orderNo) {
                clearTimeout(timer);
              }
              //二维码失效
              else if (this.error_erweima) {
                clearTimeout(timer);
              }
              //成功
              else if (data.datas.authStauts == 0) {
                clearTimeout(timer);
              }
              //失败0-成功，-1未完成，其余都是失败。
              else if (
                data.datas.authStauts != 0 &&
                data.datas.authStauts != -1
              ) {
                clearTimeout(timer);
              }
              if (this.status == 2) {
                //完成人脸
                this.getFaceResult();
                clearTimeout(timer);
              }
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //刷新二维码
    updateEr() {
      if (this.codeStatus == 0) {
        return;
      } else {
        this.error_erweima = false;
        this.getFaceAuthOrderNo();
      }
    },
    //重新认证
    resetReaml() {
      this.codeStatus = -1;
      $(".flowChart li").eq(8).find("span").removeClass("personStep");
      $(".flowChart li").eq(6).find("span").removeClass("personStep");
      $(".circle").eq(4).removeClass("personStep");
      $(".circle").eq(3).removeClass("personStep");
      $(".circle").eq(2).removeClass("personStep");
      $(".flowChart li").eq(4).find("span").removeClass("personStep");
      this.personalTabTwo = true;
      this.personalTabThree = false;
      this.personalTabFour = false;
      // this.personalTabFour1 = false;
      // this.personalTabFour2 = false;
    },
    //获取实名认证结果
    getFaceResult() {
      var timer = null;
      let orderNos = this.orderNo;
      clearTimeout(timer);
      console.log("face success status", this.codeStatus);
      if (this.codeStatus == 0) {
        BaseApi.createRpcToken(
          "/user/getFaceAuthStatus",
          { orderNo: orderNos },
          "GET"
        )
          .then(
            (data) => {
              if (data.datas.authStauts == 0) {
                $(".flowChart li").eq(6).find("span").addClass("personStep");
                $(".flowChart li").eq(8).find("span").addClass("personStep");
                $(".circle").eq(3).addClass("personStep");
                this.personalTabThree = false;
                this.personalTabFour = true;
                this.getuserId();
                setTimeout(() => {
                  this.$router.push({ path: "/personal/users/home" });
                }, 15000);
              } else {
                this.codeStatus = data.datas.authStauts;
              }
            },
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        this.codeStatus = -1;
        this.openTest = true;
        this.text = "人脸识别认证失败，请重试";
        timer = setTimeout(() => {
          this.codeStatus = -2;
          this.openTest = false;
        }, 5000);
      }
    },
    closeDialog(data) {
      // console.log(data);
      this.CheckingInformation = data;
      this.hintBoxCon = data;
    },
    lastThreeFn() {
      $(".flowChart li").eq(4).find("span").removeClass("personStep");
      $(".circle").eq(2).removeClass("personStep");
      this.personalTabTwo = true;
      this.personalTabThree = false;
    },
    //个人实名验证提交
    subCard(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var queryStres = {
            mobile: this.ruleFormP.photo,
            code: this.ruleFormP.code,
            type: "1",
          };
          BaseApi.createRpcToken("/user/checkAuthenticationCode", queryStres)
            .then(
              (data) => {
                if (data.datas.code == "200") {
                  $(".flowChart li").eq(6).find("span").addClass("personStep");
                  $(".flowChart li").eq(8).find("span").addClass("personStep");
                  $(".circle").eq(3).addClass("personStep");
                  this.personalTabThree = false;
                  this.personalTabFour = true;
                  setTimeout(() => {
                    this.$router.push({ path: "/personal/users/home" });
                  }, 2000);
                }
              },
              (data) => {}
            )
            .catch(function (e) {
              errorLog(e);
            });
        } else {
          return false;
        }
      });
    },
    getCode() {
      if (this.ruleFormP.photo != "") {
        var queryStrs = {
          mobile: this.ruleFormP.photo,
        };
        BaseApi.createRpcToken("/common/getAuthenticationCode", queryStrs)
          .then(
            (data) => {},
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimers = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timetimers);
          }
        }, 1000);
      } else {
        this.$refs.ruleFormP.validateField("photo");
      }
    },
    closeExampleFn() {
      this.exampleBox = false;
    },
    exampleBoxFn() {
      this.exampleBox = true;
    },
    handleAvatarSuccess(res, file) {
      this.loadings = false;
      this.imageUrl = res.datas.fileUrl;
      this.idcardFrontWatermakedPath = res.datas.filePath;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传的图片只能是图片格式");
      } else {
        this.loadings = true;
      }
      if (!isLt2M) {
        this.$message.error("上传的图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleAvatarSuccessc(res, file) {
      this.loadingss = false;
      this.imageUrlc = res.datas.fileUrl;
      this.idcardReverseWatermakedPath = res.datas.filePath;
    },
    beforeAvatarUploadc(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传的图片只能是图片格式!");
      } else {
        this.loadingss = true;
      }
      if (!isLt2M) {
        this.$message.error("上传的图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleAvatarSuccessz(res, file) {
      this.loadingsss = false;
      this.imageUrlz = res.datas.fileUrl;
      this.handCardWatermakedPath = res.datas.filePath;
    },
    beforeAvatarUploadz(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传的图片只能是图片格式");
      } else {
        this.loadingsss = true;
      }
      if (!isLt2M) {
        this.$message.error("上传的图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
  },
  created() {
    this.getPresonInfo();
  },
  mounted() {
    const userName = localStorage.getItem("userName");
    this.wacthRegionType();
    this.getuserId();
    if (
      /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/.test(
        userName
      )
    ) {
      this.type = true;
      this.ruleFormP.photo = userName;
    } else {
      this.type = false;
    }
  },
  components: {
    Dialog,
    breadcrumb,
    vueQr,
    faceError,
  },
};
</script>
<style lang="scss">
#canvas {
  margin: 0 auto;
  width: 200px !important;
  height: 200px !important;
  display: block;
  padding-left: 46px;
}
.no-button-click {
  background: rgba(220, 220, 220, 1);
  width: 142px;
  height: 38px;
  color: #fff;
  margin-left: 10px;
  border: 1px solid rgba(220, 220, 220, 1);
  box-sizing: border-box;
}
.resetReaml {
  display: inline-block;
  width: 160px;
  height: 40px;
  border: 1px solid #db4437;
  text-align: center;
  line-height: 40px;
  color: #db4437;
  &:hover {
    background: #db4437;
    color: #fff;
  }
}
.rlsb {
  width: 100%;
  height: 300px;
  position: relative;
  .erweima_errro {
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left: -80px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;
    .error_title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      margin-bottom: 12px;
    }
    .update_erweima {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000;
      cursor: pointer;
    }
  }
  .erweima_success {
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left: -80px;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
    .success_desc {
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }
    .success_title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      margin-top: 0px;
    }
    .success_update_erweima {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(77, 175, 247, 1);
      cursor: pointer;
    }
    img {
      opacity: 1;
    }
  }
  .rlsb_title {
    color: #1890ff;
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890ff;
      border: 0;
    }
  }
  .erweima {
    width: 160px;
    margin: 0 auto;
    height: 160px;
    img {
      width: 100%;
    }
  }
  .rlsb_desc {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
  }
  .submit_rlsb {
    width: 150px;
    height: 40px;
    background: rgba(174, 61, 74, 1);
    display: block;
    margin: 0 auto;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(230, 230, 230, 1);
    cursor: pointer;
    margin-top: 30px;
  }
}
.personalBox {
  background: #eaedf1;
  min-width: 1000px;
  box-sizing: border-box;
  .personalMain {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .hintBox {
      text-indent: 11px;
      width: 100%;
      height: 30px;
      line-height: 30px;
      background: #fbeceb;
      color: #e88078;
      font-family: "PingFangSC-Medium";
    }
    .personalCon {
      width: 100%;
      .flowChart {
        width: 100%;
        padding-top: 40px;
        padding-bottom: 43px;
        overflow: hidden;
        height: 50px;
        li {
          float: left;
          height: 20px;
        }
        li:nth-child(2n-1) {
          position: relative;
          width: calc((100% - 114px) / 5);
          span {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -1px;
            display: inline-block;
            width: 100%;
            height: 2px;
            background: #fbeceb;
            border-radius: 3px;
          }
          .personStep {
            background: #e98880;
          }
        }
        li:nth-child(2n) {
          position: relative;
          .circle {
            width: 20px;
            height: 20px;
            background: #fbeceb;
            border: 1px solid #fbeceb;
            border-radius: 50%;
            padding: 4px;
            box-sizing: border-box;
            margin: 0 4px;
            span {
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #fbeceb;
            }
          }
          .personStep {
            border: 1px solid #e88078;
            span {
              background: #e88078;
            }
          }
          p {
            position: absolute;
            width: 84px;
            color: #969696;
            top: 31px;
            left: -26px;
            text-align: center;
          }
          .personText {
            color: #505050;
          }
        }
      }

      .personalChoose {
        width: 100%;
        height: 100%;
        position: relative;

        .personalStep {
          li {
            float: left;
            width: calc(100% / 3);
            height: 140px;
            background: #f8f8f8;
            border: 1px solid #e4e8eb;
            border-left: 0;
            padding: 27px 0;
            box-sizing: border-box;
            position: relative;
            p {
              color: #969696;
              margin-top: 20px;
              opacity: 0.4;
            }
            img {
              opacity: 0.5;
            }
            b {
              display: block;
              position: absolute;
              width: 112px;
              top: 50%;
              left: 50%;
              margin-left: -56px;
              color: #787878;
            }
          }
          li:nth-child(1) {
            border-left: 1px solid #e4e8eb;
            img {
              margin-top: 4px;
            }
          }
          li:nth-child(2) {
            border: 1px solid #e98880;
            border-radius: 3px;
            background: #f8f8f8;
            opacity: 1;
            img {
              margin-top: 7px;
              opacity: 1;
            }
            p {
              margin-top: 7px;
              opacity: 1;
              color: rgba(233, 136, 128, 0.8);
            }
          }
        }
        .cardMain {
          display: flex;
          justify-content: center;
          align-items: center;
          .demo-ruleForm {
            .el-form-item {
              margin-bottom: 20px;
            }
            .el-form-item__content {
              float: left;
              line-height: 30px;
              .el-input {
                width: 300px;
                height: 30px;
                .el-input__inner {
                  width: 300px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 0;
                }
                .el-input__icon {
                  line-height: 32px;
                }
                .el-input__suffix {
                  top: 0;
                }
              }
            }
            .el-form-item__label {
              width: 94px;
              padding: 0;
              line-height: 30px;
            }
          }
          .tiJiao {
            text-align: left;
            margin-left: 84px;
            margin-top: 20px;
            span {
              display: inline-block;
              width: 125px;
              height: 32px;
              line-height: 32px;
              border: 1px solid #e29999;
              color: #e29999;
              font-family: "PingFangSC-Medium";
              text-align: center;
              background-color: #fff;
              cursor: pointer;
            }
            span:hover {
              color: #fff;
              background-color: #a5303d;
            }
            .el-button {
              border: none;
              padding: 0;
            }
            .el-button {
              margin-left: 10px;
            }
          }
          .el-input.is-disabled .el-input__inner {
            background-color: #fff;
            border-color: #e4e7ed;
            color: #606266;
            cursor: not-allowed;
          }
        }

        // 人脸识别
        .facerecognition {
          width: 1200px;
          margin: 0 auto;
        }
        .subSucceed {
          position: absolute;
          left: 50%;
          width: 592px;
          height: 100px;
          margin-left: -296px;
          margin-top: 150px;
          p {
            line-height: 50px;
            font-family: "PingFangSC-Medium";
          }
          p:nth-child(1) {
            color: #6f6f6f;
          }
          p:last-child {
            color: #6f6f6f;
          }
          img {
            width: 54px;
            height: 54px;
            vertical-align: middle;
            margin-right: 9px;
          }
        }
      }
      .personalTab {
        display: block;
      }
      .nextFn {
        display: inline-block;
        width: 140px;
        height: 36px;
        line-height: 36px;
        border: 1px solid #e29999;
        color: #e29999;
        margin-top: 40px;
        cursor: pointer;
        font-size: 14px;
      }
      .nextFn:hover {
        color: #fff;
        background-color: #a5303d;
      }
    }
    .errorBox {
      width: 100%;
      height: calc(100% - 80px);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      h3 {
        font-size: 24px;
        color: #6f6f6f;
        margin: 14px 0;
      }
      p {
        font-size: 16px;
        color: #6f6f6f;
        span {
          display: inline-block;
          border: 1px solid #db4437;
          width: 160px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          color: #db4437;
          margin-top: 30px;
        }
        span:hover {
          color: #fff;
          font-weight: normal;
          background-color: #a5303d;
        }
      }
    }
  }
  .exampleBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(100, 100, 100, 0.5);
    height: 100%;
    .conentExamp {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 580px;
      height: 300px;
      background: #fff;
      vertical-align: middle;
      text-align: center;
      margin-top: -170px;
      margin-left: -310px;
      padding: 30px;
      box-sizing: border-box;
      .exampImg {
        vertical-align: middle;
        margin-bottom: 18px;
      }
      .exampImg:nth-child(1) {
        margin-right: 10px;
      }
      p {
        color: #e88078;
        line-height: 24px;
        text-align: justify;
        img {
          margin-right: 5px;
        }
      }
      b {
        position: absolute;
        top: -5%;
        right: -23px;
      }
    }
  }
  .errorBox {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 12px;
    color: #646464;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #e4e7ed;
    color: #606266;
  }
  .face-title {
    width: 600px;
    height: 40px;
    background: #fff7f7;
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    color: #505050;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
}
.dataStartEnd {
  .el-input,
  .el-input__inner {
    width: 140px !important;
  }
  .el-input:nth-child(1) {
    margin-right: 20px;
  }
}
.search_nation_box {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 99;
  width: 100%;
  background: #fff;
  padding-top: 10px;
}
.search_nation {
  width: 89%;
  height: 34px;
  border-radius: 3px;
  background: #f2f2f2;
  margin: 0 auto;
  line-height: 34px;
  img {
    width: 14px;
    margin-left: 20px;
    float: left;
    margin-top: 12px;
  }
  input {
    font-size: 14px;
    margin-left: 5px;
  }
  input::placeholder {
    color: #9f9f9f;
  }
}
.search_nation_p .el-input.el-input--suffix .el-input__inner {
  height: 30px !important;
}
.el-select-dropdown__item.selected {
  color: #e88078 !important;
  font-weight: 700;
}

.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-date-editor .el-input.is-focus .el-input__inner,
.el-date-editor .el-input__inner:focus,
.el-form-item .el-input.is-focus .el-input__inner,
.el-form-item .el-input__inner:focus {
  border-color: #ae3d4a;
}

.gouserhome {
  color: #e61728 !important;
  font-size: 14px !important;
  cursor: pointer !important;
}
</style>
